import React from 'react';
import './style.css';

const SOCIAL_LINKS = [
	{
		id: 'facebook',
		label: 'Facebook',
		href: 'https://www.facebook.com/InsideInjuries'
	},
	{
		id: 'instagram',
		label: 'Instagram',
		href: 'https://www.instagram.com/insideinjuries'
	},
	{
		id: 'x',
		label: 'X',
		href: 'https://x.com/InsideInjuries'
	}
];

function FacebookIcon({ className }) {
	return (
		<svg className={className} viewBox='0 0 16 16' aria-hidden='true' focusable='false'>
			<path d='M8.94 6.492H7.658V4.87c0-.477.318-.588.542-.588h.67V2.005L7.946 2C6.067 2 5.64 3.418 5.64 4.327v2.165H4.5V8.75h1.14V14h2.018V8.75h1.364l.205-2.258z' />
		</svg>
	);
}

function InstagramIcon({ className }) {
	return (
		<svg className={className} viewBox='0 0 16 16' aria-hidden='true' focusable='false'>
			<path d='M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.434.372 1.942.205.526.478.972.923 1.417.444.445.89.718 1.417.923.508.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.941-.372a3.926 3.926 0 0 0 1.417-.923 3.911 3.911 0 0 0 .923-1.417c.198-.508.333-1.09.372-1.941.038-.854.048-1.126.048-3.298 0-2.174-.01-2.446-.048-3.3-.04-.851-.174-1.433-.372-1.941a3.912 3.912 0 0 0-.923-1.417A3.918 3.918 0 0 0 13.24.42c-.508-.198-1.09-.333-1.941-.372C10.444.01 10.172 0 8 0zm0 1.441c2.136 0 2.389.008 3.231.046.78.036 1.204.166 1.486.276.374.145.64.319.92.598.28.28.453.546.598.92.11.282.24.705.276 1.485.038.843.046 1.096.046 3.232s-.008 2.389-.046 3.231c-.036.78-.166 1.204-.276 1.486a2.47 2.47 0 0 1-.598.92 2.47 2.47 0 0 1-.92.598c-.282.11-.705.24-1.485.276-.843.038-1.096.046-3.232.046s-2.389-.008-3.231-.046c-.78-.036-1.204-.166-1.486-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.598-.92c-.11-.282-.24-.705-.276-1.485-.038-.843-.046-1.096-.046-3.232s.008-2.389.046-3.231c.036-.78.166-1.204.276-1.486.145-.374.319-.64.598-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.843-.038 1.096-.046 3.232-.046zm0 2.451A4.108 4.108 0 1 0 8 12.108 4.108 4.108 0 0 0 8 3.892zm0 6.775A2.667 2.667 0 1 1 8 5.333a2.667 2.667 0 0 1 0 5.334zm4.271-6.938a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92z' />
		</svg>
	);
}

function XIcon({ className }) {
	return (
		<svg className={className} viewBox='0 0 16 16' aria-hidden='true' focusable='false'>
			<path d='M9.294 6.928 14.357.75h-1.2L8.76 6.117 5.247.75H1.194l5.31 8.109L1.194 15.25h1.2l4.642-5.666 3.716 5.666h4.054L9.294 6.928Zm-1.65 2.013-.538-.765L2.83 2.094h1.844l3.45 4.907.538.765 4.486 6.391h-1.844l-3.66-5.216Z' />
		</svg>
	);
}

const ICONS = {
	facebook: FacebookIcon,
	instagram: InstagramIcon,
	x: XIcon
};

function SocialLinks({ className = '', linkClassName = '', iconClassName = '' }) {
	const socialLinksClassName = ['socialLinks', className].filter(Boolean).join(' ');
	const socialIconClassName = ['socialIcon', iconClassName].filter(Boolean).join(' ');

	return (
		<div className={socialLinksClassName}>
			{SOCIAL_LINKS.map(({ id, label, href }) => {
				const Icon = ICONS[id];

				return (
					<a
						key={id}
						href={href}
						target='_blank'
						rel='noreferrer'
						aria-label={label}
						title={label}
						className={['socialLink', `socialLink--${id}`, linkClassName].filter(Boolean).join(' ')}
					>
						<Icon className={socialIconClassName} />
					</a>
				);
			})}
		</div>
	);
}

export default SocialLinks;
